module.exports = __webpack_public_path__ + "static/media/IMG_20190826_180805.thumbnail.ec9b78a9.png";